<form [formGroup]="recurringDepositProductTermsForm">
  <div class="layout-row-wrap gap-2px responsive-column">
    <h4 class="mat-h4 flex-98">{{ 'labels.inputs.Deposit Amount' | translate }}</h4>

    <mat-form-field class="flex-31">
      <mat-label>{{ 'labels.inputs.Minimum' | translate }}</mat-label>
      <input type="number" matInput formControlName="minDepositAmount" />
    </mat-form-field>

    <mat-form-field class="flex-31">
      <mat-label>{{ 'labels.inputs.Default' | translate }}</mat-label>
      <input type="number" matInput formControlName="depositAmount" required />
      <mat-error>
        {{ 'labels.inputs.Default' | translate }} {{ 'labels.inputs.Deposit Amount' | translate }}
        {{ 'labels.commons.is' | translate }} <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-31">
      <mat-label>{{ 'labels.inputs.Maximum' | translate }}</mat-label>
      <input type="number" matInput formControlName="maxDepositAmount" />
    </mat-form-field>

    <mat-divider class="flex-98"></mat-divider>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Interest Compounding Period' | translate }}</mat-label>
      <mat-select formControlName="interestCompoundingPeriodType" required>
        @for (interestCompoundingPeriodType of interestCompoundingPeriodTypeData; track interestCompoundingPeriodType) {
          <mat-option [value]="interestCompoundingPeriodType.id">
            {{ interestCompoundingPeriodType.value }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Interest Compounding Period' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Interest Posting Period' | translate }}</mat-label>
      <mat-select formControlName="interestPostingPeriodType" required>
        @for (interestPostingPeriodType of interestPostingPeriodTypeData; track interestPostingPeriodType) {
          <mat-option [value]="interestPostingPeriodType.id">
            {{ interestPostingPeriodType.value }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Interest Posting Period' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Interest Calculated using' | translate }}</mat-label>
      <mat-select formControlName="interestCalculationType" required>
        @for (interestCalculationType of interestCalculationTypeData; track interestCalculationType) {
          <mat-option [value]="interestCalculationType.id">
            {{ interestCalculationType.value }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Interest Calculated using' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Days in Year' | translate }}</mat-label>
      <mat-select formControlName="interestCalculationDaysInYearType" required>
        @for (
          interestCalculationDaysInYearType of interestCalculationDaysInYearTypeData;
          track interestCalculationDaysInYearType
        ) {
          <mat-option [value]="interestCalculationDaysInYearType.id">
            {{ interestCalculationDaysInYearType.value }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Days in Year' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="layout-row align-center gap-2percent margin-t responsive-column">
    <button mat-raised-button matStepperPrevious>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext>
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
